import { z } from "zod";
import type { infer as zInfer } from "zod";

export const bankAccount = z.object({
  active: z.boolean(),
  bsb: z.string(),
  number: z.string(),
  createdAt: z.string(),
  id: z.string(),
  name: z.string(),
  updatedAt: z.string(),
  userId: z.string(),
  userExternalWalletId: z.string().optional(),
});

export type BankAccount = zInfer<typeof bankAccount>;
